  (function () {
    'use strict';

    // ===========================================================
    // Splide: Intro 5枚カード
    //   PC (>=960px): perPage 5、矢印・drag あり（2026-06-02: 手動送りに変更。計10枚を2グループ送り）
    //   SP (<960px) : perPage 1、focus:center + 左右 padding 11.54%、矢印あり、drag 可
    // ===========================================================
    // splide の生成 + mount + 初回 refresh をまとめたファクトリ。
    // フィルタ切替で destroy → DOM 差し替え → 再生成する際にも使い回す。
    //   loop: true → type:'loop'（「すべて」表示時。SP 両端到達で矢印 disabled を避け無限ループ）
    //   loop: false → type:'slide'（絞り込み時。枚数が少ないためループせず端で止める）
    function buildIntroSplide(el, loop) {
      // SP 配置（Figma node 908:6033 / 画面 390px 基準）:
      //   active カード幅 w=300 → 300/390 = 76.92%
      //   両端の隣カードチラ見え = (390 - 300) / 2 = 45px = 11.54% ずつ
      //   カード間 gap = 10px
      //   → focus:'center' + perPage 1 + padding 11.54% で
      //      active 幅 = 390 - 2*45 = 300px、両端チラ見え = 45px、を成立させる
      //   → padding を入れることで focus:center 時に最初/最後のカードが
      //      画面端に張り付かず、確実に中央に来る
      //   → 矢印は画面内端ピッタリ left/right: 0（CSS 側）。Figma 原案は -20px だが
      //     body の overflow-x: clip で物理的に表示できないため画面内に収める。
      // 2026-05-19: SP で両端到達時に矢印が disabled (opacity 0.5) になり、
      // ユーザーが「押せない/見えない」と感じる UX を避けるため type:'loop' で
      // 無限ループ化。PC は arrows:false / drag:false / perPage:5 の静的グリッド
      // 表示なのでループの有無は表示に影響しない（type は media をまたぐ共通設定）。
      var splide = new Splide(el, {
        type: loop ? 'loop' : 'slide',
        perPage: 5,
        gap: 10,
        arrows: false,
        pagination: false,
        drag: false,
        mediaQuery: 'min',
        breakpoints: {
          0: {
            perPage: 1,
            gap: 10,
            arrows: true,
            pagination: true,
            drag: true,
            padding: { left: '11.54%', right: '11.54%' },
            focus: 'center',
            updateOnMove: true,
          },
          960: {
            // 960〜1099px は 4 枚（狭い中間幅でカードが潰れないように）。
            perPage: 4,
            gap: 10,
            arrows: true,
            pagination: true,
            drag: true,
            padding: 0,
            focus: 0,
          },
          1100: {
            // 1100px 以上で 5 枚に戻す（他プロパティは 960 の設定を継承）。
            perPage: 5,
          },
        },
      });
      splide.mount();

      // PC（perPage 5 / type:'loop'）で初回 mount 時、Web フォント・画像・container 幅の
      // 確定前にレイアウト計算が走ると slide 幅・transform 位置がずれ、中心が揃わない
      // （矢印操作で go() が走ると再計算されて直る、の正体）。load 後に一度 refresh して補正する。
      var refreshIntro = function () { splide.refresh(); };
      if (document.readyState === 'complete') {
        refreshIntro();
      } else {
        window.addEventListener('load', refreshIntro, { once: true });
      }
      return splide;
    }

    function initIntroSplide() {
      var el = document.querySelector('.js-splide-pokemon-v3-intro');
      if (!el || typeof Splide === 'undefined') return null;
      // mount 前にオリジナルカードを確保する。
      // loop mount 後に取得すると splide が注入したクローン (.splide__slide--clone) が
      // 混入し、絞り込み後もクローンが残って枚数が増えて見える不具合になる。
      var listEl = el.querySelector('.splide__list');
      var originalSlides = listEl ? Array.prototype.slice.call(listEl.children) : [];
      // 初期表示は「すべて」= ループあり
      var splide = buildIntroSplide(el, true);
      initIntroFilter(el, splide, originalSlides);
      return splide;
    }

    // ===========================================================
    // Intro カテゴリ絞り込み（.IntroFilter のボタン群）
    //   - 各 .ProductCard の data-card-cat（半角スペース区切りの複数トークン）と
    //     ボタンの data-filter を突合し、該当カードのみを splide__list に残す。
    //   - splide は動的 add/remove より destroy(true) → DOM 差し替え → 再生成が
    //     type:'loop' のクローン整合の観点で確実なので、その方式を採る。
    //   - 元カード要素は JS 配列で保持するので「すべて」で完全復元できる。
    //     （要素自体を使い回すため ProductCard__thumb のクリックハンドラも維持される）
    // ===========================================================
    function initIntroFilter(el, initialSplide, allSlides) {
      var cards = el.closest('.Intro__cards');
      var nav = cards && cards.querySelector('.IntroFilter');
      var listEl = el.querySelector('.splide__list');
      if (!nav || !listEl || !allSlides) return;

      var btns = Array.prototype.slice.call(nav.querySelectorAll('.IntroFilter__btn'));
      var splide = initialSplide;
      // PC の実効 perPage（buildIntroSplide の breakpoints と一致させる）。
      // 1100px 以上=5枚 / 960〜1099px=4枚。該当カードがこの枚数以下ならスライド不要 → PC で矢印を消す。
      var getPcPerPage = function () {
        return (window.matchMedia && window.matchMedia('(min-width: 1100px)').matches) ? 5 : 4;
      };
      // 切替フェード: フェードアウト完了を待たず「消えきる手前」で差し替える
      // （CSS transition 0.35〜0.4s の半分強。間延びを防ぐキビキビ感）。
      var FADE_OUT_MS = 200;
      var switchTimer = null;

      // 現在 listEl 内にある全カード（loop のクローン含む）に card-fade-out を付け外し。
      function setCardsFadeOut(on) {
        var cards = listEl.querySelectorAll('.ProductCard');
        for (var i = 0; i < cards.length; i++) {
          cards[i].classList.toggle('card-fade-out', on);
        }
      }

      function matches(slide, cat) {
        if (cat === 'all') return true;
        var tokens = (slide.getAttribute('data-card-cat') || '').split(/\s+/);
        return tokens.indexOf(cat) !== -1;
      }

      // 実際の DOM 差し替え + splide 再生成。フェードの「不可視」の間に呼ぶ。
      function rebuild(cat, matched) {
        // 現 splide を破棄（completely=true でクローン・inline style を除去し DOM を元に戻す）
        if (splide) splide.destroy(true);

        // listEl を空にしてから該当カードだけを元順で再配置。
        // オリジナル li は allSlides で参照保持しているので detach しても破棄されない。
        // 登場前は card-fade-out（沈み込み）状態で配置し、loop のクローンにも継承させる。
        while (listEl.firstChild) listEl.removeChild(listEl.firstChild);
        matched.forEach(function (s) {
          s.classList.add('card-fade-out');
          listEl.appendChild(s);
        });

        // 再生成。「すべて」のみループ、絞り込み時はループ無効。
        splide = buildIntroSplide(el, cat === 'all');

        // PC: カードが perPage 未満（横幅を埋めない枚数）のときだけ中央揃え。
        // perPage ちょうど（NEW=5枚）は横幅いっぱいなので中央寄せしない
        // → justify-content:center のサブピクセルずれを避け、「すべて」と x=0 起点で揃える。
        var pcPerPage = getPcPerPage();
        el.classList.toggle('is-filtered', matched.length < pcPerPage);
        // PC: 該当カードが perPage 以下でスライド不要なら矢印を消す。
        el.classList.toggle('is-no-arrows-pc', matched.length <= pcPerPage);
      }

      // スプリングフェード: ①現カードを沈めて消す → ②消えきる手前で差し替え（新カードは
      // 沈み状態で配置）→ ③次フレーム+微小遅延で card-fade-out を外し、弾みながら登場。
      function apply(cat) {
        var matched = allSlides.filter(function (s) { return matches(s, cat); });

        // STEP1: 現在見えているカードを一斉にフェードアウト（沈み込み＋縮小）
        setCardsFadeOut(true);
        if (switchTimer) clearTimeout(switchTimer);

        // STEP2: 消えきる手前で DOM 差し替え＆ splide 再生成（新カードは fade-out 状態で配置）
        switchTimer = setTimeout(function () {
          rebuild(cat, matched);
          // STEP3: 再配置（reflow）後の次フレーム + 20ms でフェードアウトを外し、スプリング登場
          requestAnimationFrame(function () {
            switchTimer = setTimeout(function () {
              setCardsFadeOut(false);
            }, 20);
          });
        }, FADE_OUT_MS);
      }

      // SP: トグル + ドロップダウン（ポップアップ）の開閉。
      // 参考 primeday2026 floatnav。PC は CSS で select=display:contents のため通常のピル横並び。
      var toggle = nav.querySelector('.IntroFilter__toggle');
      var toggleLabel = nav.querySelector('.IntroFilter__toggleLabel');
      var overlay = nav.querySelector('.IntroFilter__overlay');

      function closeMenu() {
        nav.classList.remove('is-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
      function openMenu() {
        nav.classList.add('is-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
      }

      if (toggle) {
        toggle.addEventListener('click', function () {
          if (nav.classList.contains('is-open')) closeMenu();
          else openMenu();
        });
      }
      // オーバーレイ / メニュー外タップで閉じる
      if (overlay) overlay.addEventListener('click', closeMenu);
      document.addEventListener('click', function (ev) {
        if (nav.classList.contains('is-open') && !nav.contains(ev.target)) closeMenu();
      });

      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          // SP: 選択でトグルラベルを更新しメニューを閉じる（同じ項目選択でも閉じる）
          if (toggleLabel) toggleLabel.textContent = (btn.textContent || '').trim();
          closeMenu();
          if (btn.classList.contains('is-active')) return; // フィルタ変更不要なら以降スキップ
          btns.forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          apply(btn.getAttribute('data-filter'));
        });
      });
    }

    // ===========================================================
    // Splide: Detail（汎用）+ カスタムタブ pagination + 左右矢印
    // ===========================================================
    // .Detail__tabList の active indicator スライド更新（Faq__tabList と同方式 / 2026-05-25 追加）。
    // active タブの offsetLeft/Top/Width/Height を CSS 変数に投入し、
    // CSS 側で ::before の transform/width/height を transition で 0.45s 補間する。
    function updateDetailTabIndicator(tabsEl) {
      if (!tabsEl) return;
      var active = tabsEl.querySelector('.Detail__tab.is-active');
      if (!active) return;
      tabsEl.style.setProperty('--detail-tab-indicator-x', active.offsetLeft + 'px');
      tabsEl.style.setProperty('--detail-tab-indicator-y', active.offsetTop + 'px');
      tabsEl.style.setProperty('--detail-tab-indicator-width', active.offsetWidth + 'px');
      tabsEl.style.setProperty('--detail-tab-indicator-height', active.offsetHeight + 'px');
    }
    function initDetailTabIndicator(tabsEl) {
      if (!tabsEl) return;
      // 初期表示時はジャンプを防ぐため 1 フレーム transition を切る
      tabsEl.classList.add('is-no-anim');
      updateDetailTabIndicator(tabsEl);
      requestAnimationFrame(function () {
        // 値投入完了後に ::before を可視化（CSS visibility: hidden → visible）
        // → JS 初期化前の崩れ表示（pill が 0 width/height で見える）を防ぐ
        tabsEl.classList.add('is-initialized');
        requestAnimationFrame(function () {
          tabsEl.classList.remove('is-no-anim');
        });
      });
    }

    function initDetailSplide(splideSelector, tabSelector, opts) {
      var el = document.querySelector(splideSelector);
      var tabsEl = document.querySelector(tabSelector);
      if (!el || !tabsEl || typeof Splide === 'undefined') return null;

      // rewind は無効。first/last 到達時に Splide が prev/next 矢印へ
      // disabled 属性を自動付与 → ネイティブでクリック不可になる。
      // 視覚側は CSS の .Detail .splide__arrow:disabled で opacity / cursor を当てて伝える。
      var splide = new Splide(el, Object.assign({
        type: 'fade',
        perPage: 1,
        arrows: true,
        pagination: false,
        drag: false,
        speed: 500,
      }, opts || {}));

      // タブと splide の同期
      var tabs = Array.prototype.slice.call(tabsEl.querySelectorAll('.Detail__tab'));

      // タブクリック → splide.go
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var index = parseInt(tab.getAttribute('data-index'), 10);
          if (!isNaN(index)) splide.go(index);
        });
      });

      // ---------- サムネ自動ローテーション（_02 以降ある SKU 用 / 2026-05-25 追加）
      // active slide 内の [data-thumb-rotate] を 3 秒ごとに opacity フェードで切替。
      // 非 active になったら止めて先頭画像（is-active を 0 番目に戻す）にリセット。
      //
      // 2026-05-25 追加: クリック / タップで手動切替も可能。
      // 押した瞬間に次画像へ進め、3 秒タイマーを再起動（直後に自動切替が連発するのを防ぐ）。
      // クリックハンドラは thumb._clickBound フラグで 1 回だけ bind。
      // 現在 index と imgs NodeList は thumb element 自体に格納し、active/inactive 跨ぎでも維持。
      var ROTATE_INTERVAL_MS = 3000;
      function advanceThumb(thumb) {
        var imgs = thumb._rotateImgs;
        if (!imgs || imgs.length < 2) return;
        imgs[thumb._rotateIdx].classList.remove('is-active');
        thumb._rotateIdx = (thumb._rotateIdx + 1) % imgs.length;
        imgs[thumb._rotateIdx].classList.add('is-active');
      }
      function restartThumbTimer(thumb) {
        if (thumb._rotateTimer) clearInterval(thumb._rotateTimer);
        thumb._rotateTimer = setInterval(function () {
          advanceThumb(thumb);
        }, ROTATE_INTERVAL_MS);
      }
      function startThumbRotation(slideEl) {
        var thumb = slideEl && slideEl.querySelector('[data-thumb-rotate]');
        if (!thumb) return;
        var imgs = thumb.querySelectorAll('.Detail__visualImg');
        if (imgs.length < 2) return; // 1 枚しかない場合はローテーションしない
        // 状態を thumb 自体に格納（advance/タイマー/click ハンドラから共有参照）
        thumb._rotateImgs = imgs;
        thumb._rotateIdx = 0;
        imgs.forEach(function (img, i) {
          img.classList.toggle('is-active', i === 0);
        });
        // クリック/タップで次画像へ + タイマー再起動（1 回だけ bind）
        if (!thumb._clickBound) {
          thumb.addEventListener('click', function () {
            advanceThumb(thumb);
            restartThumbTimer(thumb);
          });
          thumb._clickBound = true;
        }
        restartThumbTimer(thumb);
      }
      function stopThumbRotation(slideEl) {
        var thumb = slideEl && slideEl.querySelector('[data-thumb-rotate]');
        if (!thumb) return;
        if (thumb._rotateTimer) {
          clearInterval(thumb._rotateTimer);
          thumb._rotateTimer = null;
        }
        var imgs = thumb.querySelectorAll('.Detail__visualImg');
        imgs.forEach(function (img, i) {
          img.classList.toggle('is-active', i === 0);
        });
      }

      // ---------- タブ切替アニメーション（2026-05-26 追加）
      // active slide 内の画像 (.Detail__visualImg.is-active) と character に
      // 入場アニメ (productIn / charIn) を再起動。
      //
      // 「アニメ再起動」は classList.remove → reflow → classList.add のクラシック手法。
      // void el.offsetWidth で reflow を強制し、同フレーム内で外して付けても確実に再生される。
      function restartEntranceAnim(slideEl) {
        if (!slideEl) return;
        // 画像 (active 1 枚) と character。両方とも slide 内に 0〜複数。
        // CSS 側で `.Detail__slide.is-active .Detail__visualImg.is-active.is-anim-in`
        // と `.Detail__slide.is-active .Detail__character.is-anim-in` にアニメ定義。
        var targets = [];
        var activeImg = slideEl.querySelector('.Detail__visualImg.is-active');
        if (activeImg) targets.push(activeImg);
        Array.prototype.slice.call(slideEl.querySelectorAll('.Detail__character'))
          .forEach(function (c) { targets.push(c); });
        if (targets.length === 0) return;
        // クラスを外す
        targets.forEach(function (el) { el.classList.remove('is-anim-in'); });
        // reflow 強制（dummy 読み出しで合成スレッドを切り離す）
        // eslint-disable-next-line no-unused-expressions
        void slideEl.offsetWidth;
        // 同フレームで付け直し → アニメが再生される
        // アニメ完了で is-anim-in を外す。以降のサムネ自動切替・クリック切替では
        // CSS の既存フェード (`.Detail__visualImg` の transition: opacity 0.6s) に任せる。
        targets.forEach(function (el) {
          // is-revealed は永続 — animation 完了後の表示維持に必要
          el.classList.add('is-revealed');
          el.classList.add('is-anim-in');
          var timer;
          var clear = function () {
            el.classList.remove('is-anim-in');
            el.removeEventListener('animationend', clear);
            if (timer) clearTimeout(timer);
          };
          el.addEventListener('animationend', clear);
          // フォールバック: animation cancel 等で animationend が失火しても取り残さない（charIn 最長 0.67s）
          timer = setTimeout(clear, 1000);
        });
      }

      // splide active 変化 → タブ active 同期＋サムネローテーション開始＋indicator スライド更新。
      // active slide が `.-pikachu` modifier を持つときは親 `.Detail` に `-pikachu-active` を付与
      // （audio セクションの bg をピカチュウテーマ #FFEF8C へフェード）。
      var detailEl = el.closest('.Detail');
      // 初回 mount の on('active') では入場アニメをスキップ。画面外で先にアニメが走ると
      // ユーザー到達時に既に表示済み → IO 経路の再発火で点滅する。初回は IO 経路に一任。
      var isFirstActive = true;
      splide.on('active', function (newSlide) {
        tabs.forEach(function (t, i) {
          if (i === newSlide.index) t.classList.add('is-active');
          else t.classList.remove('is-active');
        });
        startThumbRotation(newSlide.slide);
        updateDetailTabIndicator(tabsEl);
        if (detailEl) {
          var isPikachuSlide = newSlide.slide.classList.contains('-pikachu');
          detailEl.classList.toggle('-pikachu-active', isPikachuSlide);
        }
        if (isFirstActive) {
          isFirstActive = false;
          return;
        }
        // 入場アニメ（2 回目以降のタブ切替）
        restartEntranceAnim(newSlide.slide);
      });
      // 非 active 化 → ローテーション停止＋先頭画像にリセット
      splide.on('inactive', function (oldSlide) {
        stopThumbRotation(oldSlide.slide);
      });

      // slide 切替時に新 active slide 内のバッジ wobble を再発火（moved は mount 時に発火しないため初回スキップ）。
      // -audio は slide ごとに badge があるので slide 内から取得。
      // -charger は全 slide 共通の badge を Detail__card 直下に外出ししているので、slide 内に無ければ親 (=Detail__card) から取得する。
      splide.on('moved', function (newIndex) {
        var slideObj = splide.Components.Slides.getAt(newIndex);
        var slideEl = slideObj && slideObj.slide;
        var badge = (slideEl && slideEl.querySelector('.Detail__visualBadge'))
          || (el.parentElement && el.parentElement.querySelector('.Detail__visualBadge[data-fixed-overlay]'));
        if (!badge) return;
        badge.classList.remove('is-visible');
        // eslint-disable-next-line no-unused-expressions
        void badge.offsetWidth;
        badge.classList.add('is-visible');
      });

      splide.mount();
      // mount 後に初期 indicator 位置を設定（is-active 0 番目に合わせて transition なしで配置）
      initDetailTabIndicator(tabsEl);
      // viewport リサイズで cqw が動いた時に indicator も追従
      window.addEventListener('resize', function () {
        updateDetailTabIndicator(tabsEl);
      });
      return splide;
    }

    // ---------- Page Visibility API + IntersectionObserver: サムネローテーション停止 / 再開
    // 2026-05-25 追加。design-review 指摘 (二重登録): listener を initDetailSplide 内に置くと
    // detail1 / detail2 で 2 回登録されてしまうため、init() から 1 度だけ呼ぶ関数に切り出した。
    // 対象は .page-pokemon-v3 .Detail 内の全 [data-thumb-rotate]。
    //
    // 2026-05-25 追加 (再): タブ非表示だけでなくスクロールで画面外に出たときも止めるよう
    // IntersectionObserver を併用（ユーザー指示「画面外で止めて」）。
    function initThumbRotationVisibility() {
      // 共通: アクティブな thumb を「再生開始」する関数（visibilitychange 復帰時と
      // IntersectionObserver で表示中に入ったときの両方から呼ぶ）
      function resumeRotationForActiveSlides(scopeEl) {
        var root = scopeEl || document;
        var activeSlides = root.querySelectorAll('.page-pokemon-v3 .Detail .splide__slide.is-active');
        activeSlides.forEach(function (slide) {
          var thumb = slide.querySelector('[data-thumb-rotate]');
          if (!thumb) return;
          var imgs = thumb.querySelectorAll('.Detail__visualImg');
          if (imgs.length < 2) return;
          thumb._rotateImgs = imgs;
          if (typeof thumb._rotateIdx !== 'number') thumb._rotateIdx = 0;
          if (thumb._rotateTimer) clearInterval(thumb._rotateTimer);
          thumb._rotateTimer = setInterval(function () {
            imgs[thumb._rotateIdx].classList.remove('is-active');
            thumb._rotateIdx = (thumb._rotateIdx + 1) % imgs.length;
            imgs[thumb._rotateIdx].classList.add('is-active');
          }, 3000);
        });
      }
      // 共通: scope 内の全 thumb のタイマーを停止
      function stopAllRotationIn(scopeEl) {
        var root = scopeEl || document;
        var thumbs = root.querySelectorAll('.page-pokemon-v3 .Detail [data-thumb-rotate]');
        thumbs.forEach(function (thumb) {
          if (thumb._rotateTimer) {
            clearInterval(thumb._rotateTimer);
            thumb._rotateTimer = null;
          }
        });
      }

      // タブ visibility（既存）
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stopAllRotationIn(document);
        } else {
          resumeRotationForActiveSlides(document);
        }
      });

      // スクロールで画面外になった場合の停止 / 復帰
      if (!('IntersectionObserver' in window)) return;
      var details = document.querySelectorAll('.page-pokemon-v3 .Detail');
      if (!details.length) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // セクションが少しでも表示 → 配下の active slide ローテーション再開
            resumeRotationForActiveSlides(entry.target);
          } else {
            // セクション完全に画面外 → 配下の全 thumb タイマー停止
            stopAllRotationIn(entry.target);
          }
        });
      }, { threshold: 0 });
      details.forEach(function (detail) {
        io.observe(detail);
      });
    }

    // ===========================================================
    // FAQ: 開閉アコーディオン（::details-content + interpolate-size 方式・現行 v4）
    //
    // 方針: <details> のネイティブ開閉セマンティクスを保持しつつ、
    //   <details> 公式の UA slot 疑似要素 ::details-content に直接 transition を
    //   当てる。height: 0 ↔ auto を interpolate-size + allow-discrete で補間し、
    //   opacity / content-visibility も併せて transition する。
    //
    // ブラウザ別の見え方:
    //   - Chrome (129+): height 補間が効いて滑らかに開閉
    //   - Firefox / Safari: interpolate-size 未対応のため height は即時切替フォールバック。
    //     opacity フェード（通常プロパティ・3 ブラウザ対応）と content-visibility の
    //     allow-discrete スナップは効くので、機能としては動く・カクつかない。
    //   - ::details-content 擬似要素自体は Baseline 2025 で 3 ブラウザ対応。
    //
    // 履歴:
    //   - 初期: max-height transition 方式 → scrollHeight 計測 / 強制 reflow / Safari でカクつき
    //   - v2: grid-template-rows 0fr↔1fr 方式 → <details> 閉時の UA slot (content-visibility:
    //     hidden) と grid container の相性問題で最新 Chrome 実機で機能せず（grid 補間値が
    //     状態切替時にスナップで失われた）
    //   - v3: ::details-content + interpolate-size 方式（初導入）
    //   - v4 (現行・2026-05-19): ::details-content 方式継続。DOM 注入完全廃止、JS は
    //     data-js-accordion="ready" 付与のみに最小化。CSS フォールバック保険は維持。
    //
    // JS の役割（最小化）:
    //   - data-js-accordion="ready" を <section.Faq> に付与し、
    //     CSS 側のフォールバック保険 (:not([open]) > *:not(summary) クリッピング) を打ち消す
    //   - それ以外は触らない。<details> のネイティブ open/close は CSS の
    //     ::details-content transition でそのまま動く
    //
    // prefers-reduced-motion: reduce: CSS 側の transition-duration: 0s で即時切替
    //   （JS では何もしない。ネイティブ <details> 動作にそのまま委譲できる）
    //
    // 過去バグ非再発:
    //   - <summary> の display: list-item は CSS 側で維持（JS は触らない）
    //   - <details> ネイティブ slot を踏み抜かない（toggle ハンドラも作らない）
    //   - 初期 open 属性なし状態は CSS 初期値 ::details-content { height: 0 } で
    //     中身が一瞬見える事故も発生しない
    // ===========================================================
    function initFaqAccordion() {
      var faqSections = document.querySelectorAll('.page-pokemon-v3 .Faq');
      if (!faqSections.length) return;

      faqSections.forEach(function (faq) {
        // JS 起動完了を示すフラグ → CSS フォールバック保険を打ち消す
        // これで data-js-accordion="ready" を <section.Faq> に付与し、
        // 過去バグ非再発のための CSS フォールバック（JS なし時の物理クリッピング）を解除する
        faq.setAttribute('data-js-accordion', 'ready');
      });
    }

    // ===========================================================
    // FAQ: カテゴリタブ（aria-tabs パターン、splide ではない）
    //
    // 切替アニメ: スペースシリーズ (.Reviews__tabs) と同じ「indicator スライド」方式。
    //   - active タブの offsetLeft/Top/Width/Height を CSS 変数に投入し
    //     .Faq__tabList::before を transform/width/height で 0.45s 補間させる
    //   - 初期表示時は .is-no-anim を一瞬付与して transition: none にし、
    //     初期位置への「ジャンプ」を防ぐ（次フレームで解除）
    //   - フォント読込後 / リサイズ時にも再計算（タブ幅が変わるため）
    //
    // パネル切替: スペースシリーズ (.Reviews__stack) と同じ「Grid 同一セル重ね」方式
    //   (2026-05-19 追加 — タブ切替時の高さガタつき防止)。
    //   - 親 .Faq__panels を display: grid にし、2つの .Faq__panel を 1/1 セルに重ねる
    //   - 非 active は opacity: 0 / visibility: hidden / pointer-events: none + inert 属性
    //   - active は is-active class で逆に切替
    //   - 親 .Faq__panels の高さは JS で px 値を明示投入して補間
    //     （grid auto sizing の auto ↔ auto 補間はブラウザ実装依存で確実性に欠けるため、
    //      JS で「現在高さ → 次パネル高さ」を明示し、CSS transition: height で確実に補間する）
    //     全モダンブラウザで動作（interpolate-size 非対応ブラウザでも滑らかに動く）
    //   - transitionend 後に .Faq__panels.style.height を空に戻し、
    //     以降のアコーディオン開閉時は auto 追従に委ねる（案 A 採用）
    //   - prefers-reduced-motion: reduce で CSS transition 切る + JS でも height 投入をスキップ
    //
    // a11y:
    //   - 非 active panel は inert 属性のみで隔離（フォーカス/AT インタラクション/クリックを完全遮断）
    //   - aria-hidden は付与しない（inert があれば tabpanel 内の名前/役割は AT に正しく伝わる）
    //   - WAI-ARIA APG Tabs (Manual Activation) パターンと整合
    // ===========================================================
    function updateFaqTabIndicator(tabList) {
      if (!tabList) return;
      var active = tabList.querySelector('[aria-selected="true"]');
      if (!active) return;
      tabList.style.setProperty('--faq-tab-indicator-x', active.offsetLeft + 'px');
      tabList.style.setProperty('--faq-tab-indicator-y', active.offsetTop + 'px');
      tabList.style.setProperty('--faq-tab-indicator-width', active.offsetWidth + 'px');
      tabList.style.setProperty('--faq-tab-indicator-height', active.offsetHeight + 'px');
    }
    function initFaqTabIndicator(tabList) {
      if (!tabList) return;
      tabList.classList.add('is-no-anim');
      updateFaqTabIndicator(tabList);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          tabList.classList.remove('is-no-anim');
        });
      });
    }

    function initFaqTabs() {
      var tabLists = document.querySelectorAll('.page-pokemon-v3 .Faq__tabList');
      var lists = Array.prototype.slice.call(tabLists);
      var reduceMotionMql = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

      lists.forEach(function (tabList) {
        var tabs = Array.prototype.slice.call(tabList.querySelectorAll('[role="tab"]'));
        if (!tabs.length) return;

        // 同 tabList が制御する panels ラッパー（.Faq__panels）を特定。
        // 全 tab の aria-controls から共通の親 .Faq__panels を辿る。
        var firstPanel = document.getElementById(tabs[0].getAttribute('aria-controls'));
        var panelsWrap = firstPanel ? firstPanel.closest('.Faq__panels') : null;

        // height 補間用の transitionend ハンドラ（1回限りで自動 detach）
        function clearPanelsHeight() {
          if (!panelsWrap) return;
          panelsWrap.style.height = '';
        }

        function animatePanelsHeight(nextPanel, fromH) {
          // panels ラッパーが取れない or reduced-motion → 即時切替
          if (!panelsWrap || !nextPanel) return;
          if (reduceMotionMql && reduceMotionMql.matches) {
            panelsWrap.style.height = '';
            return;
          }

          // 2026-05-25 改修: CSS transition + style.height 投入方式から WAAPI (element.animate) へ切替。
          // 旧方式は (1) フレーム N で `style.height = fromH+'px'` 投入 → (2) フレーム N+1 RAF で
          // `style.height = toH+'px'` 投入のシーケンスで、ブラウザの specified value batching に
          // よって transition が走らない/不安定なケースがあった（ユーザー観察: ガクッと動く）。
          // WAAPI なら ブラウザの transition trigger 判定に依存せず、from → to の height 補間を
          // element.animate() で確実に 0.45s で走らせられる。子の中間 height に親 .Faq の auto
          // height も自然追従し、結果として `.Faq__characters` (position:absolute; top:50%) の
          // used value も滑らかに動く。

          // fromH を style.height として固定（animate の "from" 状態と整合 / レイアウト anchor）
          panelsWrap.style.height = fromH + 'px';

          requestAnimationFrame(function () {
            // scrollHeight は parent height 制約に影響されず content の自然高さを返す
            var toH = nextPanel.scrollHeight;
            if (toH === fromH) {
              panelsWrap.style.height = '';
              return;
            }

            // WAAPI で height を確実に補間
            var anim = panelsWrap.animate(
              [{ height: fromH + 'px' }, { height: toH + 'px' }],
              {
                duration: 450,
                easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
                fill: 'forwards'
              }
            );

            anim.onfinish = function () {
              // forwards fill を解除し、style.height を空に戻して auto に復帰。
              // 新 active panel の自然高さ = toH と一致するため、視覚的にジャンプなし。
              anim.cancel();
              panelsWrap.style.height = '';
            };
            anim.oncancel = function () {
              panelsWrap.style.height = '';
            };
          });
        }

        function activate(tab) {
          // 次 active panel を先に特定（高さ補間のため）
          var nextPanel = document.getElementById(tab.getAttribute('aria-controls'));

          // class toggle 前に旧 active 高さをキャプチャしておく。
          // is-active を toggle すると旧 active が position: absolute 化し
          // panelsWrap.offsetHeight が新 active の高さ (toH) と一致してしまい
          // animatePanelsHeight 内の早期 return で transition が走らなくなるため。
          var fromH = panelsWrap ? panelsWrap.offsetHeight : 0;

          tabs.forEach(function (t) {
            var panel = document.getElementById(t.getAttribute('aria-controls'));
            var isActive = t === tab;
            t.setAttribute('aria-selected', isActive ? 'true' : 'false');
            t.setAttribute('tabindex', isActive ? '0' : '-1');
            if (panel) {
              // 2026-05-19 改訂: パネルは grid 同一セル重ねでクロスフェード + 高さ補間する。
              // hidden 属性 (display: none) を使うと grid 重ねが壊れ、display 切替は
              // 補間できないため、is-active class で opacity/visibility/pointer-events を切替える。
              // 非 active 側はキーボードフォーカス/タブ移動を弾くため inert を当てる
              // （aria-hidden は付与しない — APG Tabs パターンと整合させ inert で隔離）。
              panel.classList.toggle('is-active', isActive);
              if (isActive) panel.removeAttribute('inert');
              else panel.setAttribute('inert', '');
            }
          });

          // パネル高さを JS で明示補間（class toggle 前にキャプチャした fromH を引き渡す）
          animatePanelsHeight(nextPanel, fromH);

          updateFaqTabIndicator(tabList);
        }

        tabs.forEach(function (tab, idx) {
          tab.addEventListener('click', function (e) {
            e.preventDefault();
            activate(tab);
            tab.focus();
          });
          tab.addEventListener('keydown', function (e) {
            var nextIdx = null;
            if (e.key === 'ArrowRight') nextIdx = (idx + 1) % tabs.length;
            else if (e.key === 'ArrowLeft') nextIdx = (idx - 1 + tabs.length) % tabs.length;
            else if (e.key === 'Home') nextIdx = 0;
            else if (e.key === 'End') nextIdx = tabs.length - 1;
            if (nextIdx !== null) {
              e.preventDefault();
              activate(tabs[nextIdx]);
              tabs[nextIdx].focus();
            }
          });
        });

        // 初期化: 非 active パネルに inert を当てる。
        // active パネルからは inert を外す（Liquid 側で is-active を付与済み）。
        tabs.forEach(function (t) {
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (!panel) return;
          var isActive = t.getAttribute('aria-selected') === 'true';
          if (isActive) panel.removeAttribute('inert');
          else panel.setAttribute('inert', '');
        });

        // 初期表示時は panels ラッパー height は触らない（auto で grid auto sizing に任せる）
        // → 以降のタブ切替時のみ JS が height を一時的に px 固定 → 次値 → 空に戻す。

        // 初期位置（ジャンプ防止のため transition を一瞬切ってから配置）
        initFaqTabIndicator(tabList);
      });

      // フォント読込後にもタブ幅が変わるため再計算
      if (lists.length && document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          lists.forEach(updateFaqTabIndicator);
        });
      }

      // リサイズ時にも再計算（rAF でデバウンス）
      if (lists.length) {
        var resizeRaf = null;
        window.addEventListener('resize', function () {
          if (resizeRaf) cancelAnimationFrame(resizeRaf);
          resizeRaf = requestAnimationFrame(function () {
            lists.forEach(updateFaqTabIndicator);
          });
        });
      }
    }

    // ===========================================================
    // KV エントランス
    //   - 8枚の Kv__img にランダム順の --kv-delay を割当
    //   - 次フレームで .is-loaded を付与し、CSS の transition でふわっと登場
    // ===========================================================
    function initKvAnimation() {
      var kv = document.querySelector('.js-kv');
      if (!kv) return;

      var imgs = kv.querySelectorAll('.Kv__img');
      var count = imgs.length;
      if (count) {
        // 0..count-1 の順序配列を Fisher–Yates でシャッフル
        var order = [];
        for (var i = 0; i < count; i++) order.push(i);
        for (var i = count - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var tmp = order[i]; order[i] = order[j]; order[j] = tmp;
        }
        // Figma の段階に合わせ、ロゴ→テキスト→キャラ 完了後（1.85s）から開始
        // 0.10s 刻みでスタガー（最後の画像は 2.55s 開始）
        var startDelay = 1.85;
        var step = 0.10;
        Array.prototype.forEach.call(imgs, function (img, idx) {
          img.style.setProperty('--kv-delay', (startDelay + order[idx] * step).toFixed(2) + 's');
        });
      }

      function fireKvEntrance() {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            void kv.offsetHeight;
            Array.prototype.forEach.call(imgs, function (img) {
              void getComputedStyle(img).opacity;
            });
            kv.classList.add('is-loaded');
            setTimeout(function () {
              startKvBounceLoop(kv);
            }, 3600);
          });
        });
      }
      // window.load はページ全リソース完了まで発火しないため、KV 内の画像だけを待つ。
      // ただし画像がキャッシュ済みだと初回描画前に is-loaded が付き、transition が
      // 画面に映らないまま完了してしまうので、「KV が一度実際に描画されたこと」
      // （IntersectionObserver の初回コールバック = レンダリング後）も発火条件にする。
      (function waitKvImagesOnly() {
        var fired = false;
        var imgsReady = false;
        var rendered = false;
        function tryFire() {
          if (fired || !imgsReady || !rendered) return;
          fired = true;
          fireKvEntrance();
        }
        if ('IntersectionObserver' in window) {
          var renderIo = new IntersectionObserver(function () {
            rendered = true;
            renderIo.disconnect();
            tryFire();
          });
          renderIo.observe(kv);
        } else {
          rendered = true;
        }
        var kvImgs = kv.querySelectorAll('img');
        var pending = 0;
        Array.prototype.forEach.call(kvImgs, function (img) {
          if (img.complete) return;
          pending++;
          function done() {
            pending--;
            if (pending === 0) {
              imgsReady = true;
              tryFire();
            }
          }
          img.addEventListener('load', done, { once: true });
          img.addEventListener('error', done, { once: true });
        });
        if (pending === 0) imgsReady = true;
        // 保険: 何かが詰まっても 3s で強制発火
        setTimeout(function () {
          imgsReady = true;
          rendered = true;
          tryFire();
        }, 3000);
        tryFire();
      })();

      // resize 中は KV 内の transition を一時停止（SP↔PC 切替時に pikachu/eevee の transform 値
      // が変わって発火する横滑り遷移を抑止 / 2026-05-26 ユーザー指示）。
      // CSS 側で `.Kv.is-resizing .Kv__pikachu, ...` に transition: none を指定。
      var kvResizeTimer = null;
      window.addEventListener('resize', function () {
        kv.classList.add('is-resizing');
        if (kvResizeTimer) clearTimeout(kvResizeTimer);
        kvResizeTimer = setTimeout(function () {
          kv.classList.remove('is-resizing');
        }, 100);
      });
    }

    // ===========================================================
    // KV 背景の製品画像をランダムに「上下バウンス」させる無限ループ。
    // - 対象は表示中の .Kv__img のみ（offsetParent 判定で display:none を除外）
    // - 発火ごとに 1 枚抽出 + .is-bouncing を 0.95s 付与（CSS animation 0.9s と同期）
    // - 次の発火まで 3-6s ランダム待機
    // ===========================================================
    function startKvBounceLoop(kv) {
      var imgs = kv.querySelectorAll('.Kv__img');
      // KV が画面外 or タブ非表示の間は tick 自体を止める（CPU/レイアウト計算の節約 / 2026-07-06 軽量化）
      var kvInView = true;
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          kvInView = entries[0].isIntersecting;
        }, { threshold: 0 });
        io.observe(kv);
      }
      function tick() {
        if (kvInView && !document.hidden) {
          var visible = [];
          Array.prototype.forEach.call(imgs, function (img) {
            if (img.offsetParent !== null && !img.classList.contains('is-bouncing')) {
              visible.push(img);
            }
          });
          if (visible.length) {
            var target = visible[Math.floor(Math.random() * visible.length)];
            target.classList.add('is-bouncing');
            setTimeout(function () {
              target.classList.remove('is-bouncing');
            }, 950);
          }
        }
        var nextDelay = 1500 + Math.random() * 1500; // 1.5-3s
        setTimeout(tick, nextDelay);
      }
      tick();
    }

    // ===========================================================
    // タイトル系を 1 文字ずつ stagger reveal（汎用化 / 2026-05-26）
    // - 各文字を <span class="Intro__titleChar"> に分解（<br> や spOnly span などはそのまま温存）
    //   ※ class 名は既存の Intro 用を流用（CSS でも Intro__title / Detail__headingText 両方に適用）。
    //   ※ `Intro__char` (キャラ画像) と衝突するため `Intro__titleChar` を使う
    // - --char-delay を index × 50ms で設定
    // - IntersectionObserver で見えたタイミングで .is-revealed 付与 → CSS transition でフェードイン
    // ===========================================================
    function initTitleReveal(selector) {
      var titles = document.querySelectorAll(selector);
      if (!titles.length) return;

      titles.forEach(function (title) {
        // 全 textNode を再帰的に 1 文字 span に置換（要素ごとに index は 0 リセット）
        var charIndex = 0;
        (function walk(node) {
          var children = Array.prototype.slice.call(node.childNodes);
          children.forEach(function (child) {
            if (child.nodeType === 3) { // TEXT_NODE
              var text = child.textContent;
              var frag = document.createDocumentFragment();
              for (var i = 0; i < text.length; i++) {
                var ch = text.charAt(i);
                // 改行・スペース類はそのままテキストノードで残す（span 化しない）
                if (ch === '\n' || ch === '\r' || ch === '\t' || ch === ' ') {
                  frag.appendChild(document.createTextNode(ch));
                  continue;
                }
                var span = document.createElement('span');
                span.className = 'Intro__titleChar';
                span.textContent = ch;
                span.style.setProperty('--char-delay', (charIndex * 50) + 'ms');
                frag.appendChild(span);
                charIndex++;
              }
              child.parentNode.replaceChild(frag, child);
            } else if (child.nodeType === 1) { // ELEMENT_NODE
              // <br> はそのまま、span 系（spOnly 句点など）の中は再帰
              if (child.tagName && child.tagName.toLowerCase() === 'br') return;
              walk(child);
            }
          });
        })(title);

        if (!('IntersectionObserver' in window)) {
          title.classList.add('is-revealed');
          return;
        }
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              // 同タイミングで親 .Intro 内の .Intro__bgChar にも is-visible を付与（弧アニメ発火）。
              var section = entry.target.closest('.Intro');
              if (section) {
                section.querySelectorAll('.Intro__bgChar').forEach(function (charEl) {
                  charEl.classList.add('is-visible');
                });
              }
              io.unobserve(entry.target);
            }
          });
        // 2026-05-26: もう少し画面に入ってから発火（0.2 → 0.4 / ユーザー指示）。
        // 2026-06-02: threshold だけだと画面下端で即発火し「半分くらいスクロールしてから」の
        //   溜めが消えていたため、rootMargin 下 inset -200px を追加（旧 initVisibilityObserver
        //   経路が作っていた溜めに相当）。トリガーは小さい title 要素基準なので bgChar の早発火は起きない。
        }, { threshold: 0.4, rootMargin: '0px 0px -200px 0px' });
        io.observe(title);
      });
    }

    // ===========================================================
    // IntersectionObserver で is-visible 付与
    // ===========================================================
    function initVisibilityObserver() {
      // .Intro__char はこの IO から除外。rootMargin -200px / threshold 0 だと intro が画面に入る前に
      // 発火し、ユーザーが視認する頃にはアニメが完了してしまうため（2026-05-27）。
      // is-visible 付与は initTitleReveal('.Intro__title') の threshold:0.4 経路（行 1979-1985）に
      // 一本化し、タイトルが画面に十分入ったタイミングと同期させる。
      var targets = document.querySelectorAll(
        '.page-pokemon-v3 .is-fadeIn, .page-pokemon-v3 .is-fadeInLeft, .page-pokemon-v3 .is-fadeInRight, .page-pokemon-v3 .Detail__visualBadge'
      );
      if (!targets.length) return;

      if (!('IntersectionObserver' in window)) {
        targets.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      // 2026-05-26: もう少し画面に入ってから発火（rootMargin の bottom inset を -100 → -200 / ユーザー指示）。
      }, { threshold: 0, rootMargin: '0px 0px -200px 0px' });

      targets.forEach(function (el) { io.observe(el); });
    }

    // ===========================================================
    // Lifestyle marquee（2026-05-27 改修）:
    //   旧 Splide AutoScroll は hard reload 時に translateX -3e+07px 級の暴走が
    //   再発するため、CSS keyframes marquee に置き換え。JS が担うのは:
    //     1) 画面外時の animation-play-state: paused（CPU 節約）
    //     2) viewport 中央に最も近い .Lifestyle__photo へ .is-active 付与
    //        （旧 Splide focus:'center' の中央拡大演出を再現）
    // ===========================================================
    function initLifestyleMarquee() {
      var section = document.querySelector('.js-lifestyle-marquee');
      if (!section) return;
      var list = section.querySelector('.Lifestyle__list');
      if (!list) return;
      var photos = Array.prototype.slice.call(list.querySelectorAll('.Lifestyle__photo'));
      if (!photos.length) return;
      if (!('IntersectionObserver' in window)) return;

      var viewportCenter = window.innerWidth / 2;
      var rafId = 0;
      var running = false;

      function update() {
        // viewport 中央に最も近い photo を選んで .is-active 切替。
        // rect.left + width/2 を中心点として比較。.is-active の scale 1.04 は
        // transform-origin: center なので幾何中心は変動せず、フィードバックループは起きない。
        var closest = null;
        var closestDist = Infinity;
        for (var i = 0; i < photos.length; i++) {
          var rect = photos[i].getBoundingClientRect();
          var center = rect.left + rect.width / 2;
          var dist = Math.abs(center - viewportCenter);
          if (dist < closestDist) {
            closestDist = dist;
            closest = photos[i];
          }
        }
        for (var j = 0; j < photos.length; j++) {
          var shouldActive = photos[j] === closest;
          if (shouldActive !== photos[j].classList.contains('is-active')) {
            photos[j].classList.toggle('is-active', shouldActive);
          }
        }
        if (running) {
          rafId = requestAnimationFrame(update);
        }
      }

      function start() {
        if (running) return;
        running = true;
        list.style.animationPlayState = 'running';
        rafId = requestAnimationFrame(update);
      }

      function stop() {
        running = false;
        if (rafId) cancelAnimationFrame(rafId);
        rafId = 0;
        list.style.animationPlayState = 'paused';
      }

      window.addEventListener('resize', function () {
        viewportCenter = window.innerWidth / 2;
      });

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) start();
          else stop();
        });
      }, { threshold: 0 });
      io.observe(section);
    }

    // SP: .Detail (charger / audio) 内 .Detail__tabList を sticky (固定ヘッダー下に吸着)。
    // soundcore-space の Products__tabs sticky 実装と同じパターン。
    function initDetailTabSticky(sectionSelector) {
      var section = document.querySelector(sectionSelector);
      var tabsEl = section && section.querySelector('.Detail__tabList');
      var spacer = section && section.querySelector('.Detail__tabList-spacer');
      var overlay = section && section.querySelector('.Detail__tabList-overlay');
      if (!section || !tabsEl || !spacer || !overlay) return;

      var isFixed = false;
      var isTicking = false;
      // Figma 868:12770 — sticky tab は header の下 10px に固定
      var GAP_BELOW_HEADER = 10;

      // header (Shopify section または v2-header-sticky) の現在の bottom 位置。
      // header が画面外（scroll で消えた）の場合は 0 を返す。
      function getHeaderBottom() {
        var header = document.querySelector('.v2-header-sticky.is-show')
          || document.getElementById('shopify-section-v2-header')
          || document.querySelector('.v2-header-sticky')
          || document.querySelector('.js-v2-header-sticky');
        if (!header) return 0;
        var rect = header.getBoundingClientRect();
        return rect.bottom > 0 ? rect.bottom : 0;
      }

      function update() {
        // PC では sticky 無効化（PC は左右2カラム + タブ overhang デザイン）
        if (window.innerWidth >= 960) {
          if (isFixed) {
            tabsEl.classList.remove('is-fixed');
            overlay.classList.remove('is-show');
            spacer.style.display = 'none';
            tabsEl.style.removeProperty('--pkmn-tab-sticky-top');
            isFixed = false;
          }
          isTicking = false;
          return;
        }

        var headerBottom = getHeaderBottom();
        var stickyTop = headerBottom + GAP_BELOW_HEADER;
        var tabsH = tabsEl.offsetHeight;
        var sectionRect = section.getBoundingClientRect();
        var anchorRect = isFixed
          ? spacer.getBoundingClientRect()
          : tabsEl.getBoundingClientRect();

        var shouldFix = anchorRect.top <= stickyTop;
        // セクションが画面外へ抜けたか（底が sticky tab の下端より上に来た）
        var sectionExited = sectionRect.bottom <= stickyTop + tabsH;

        if (shouldFix && !sectionExited) {
          if (!isFixed) {
            spacer.style.display = 'block';
            spacer.style.height = tabsH + 'px';
            // 初回 sticky 化: CSS の top: 10px → inline の headerBottom+10px ジャンプが
            // CSS transition (top 0.3s) で補間されてしまうのを防ぐため、一瞬無効化。
            tabsEl.style.transition = 'none';
            tabsEl.classList.add('is-fixed');
            overlay.classList.add('is-show');
            isFixed = true;
            tabsEl.style.setProperty('--pkmn-tab-sticky-top', stickyTop + 'px');
            // 次フレームで transition を戻し、以降のヘッダー追従を滑らかに。
            requestAnimationFrame(function () {
              tabsEl.style.transition = '';
            });
          } else {
            // 2回目以降の update: ヘッダーの上下動に CSS transition で滑らかに追従。
            tabsEl.style.setProperty('--pkmn-tab-sticky-top', stickyTop + 'px');
          }
          // 上から戻ってきたタイミングで万一 is-exiting が残っていれば除去
          if (tabsEl.classList.contains('is-exiting')) {
            tabsEl.classList.remove('is-exiting');
            overlay.classList.remove('is-exiting');
          }
        } else if (isFixed && sectionExited) {
          // セクション抜け → 上にスライドアウトするアニメ（CSS transition 0.3s）
          if (!tabsEl.classList.contains('is-exiting')) {
            tabsEl.classList.add('is-exiting');
            overlay.classList.add('is-exiting');
            setTimeout(function () {
              tabsEl.classList.remove('is-fixed');
              tabsEl.classList.remove('is-exiting');
              overlay.classList.remove('is-show');
              overlay.classList.remove('is-exiting');
              spacer.style.display = 'none';
              tabsEl.style.removeProperty('--pkmn-tab-sticky-top');
            }, 300);
            isFixed = false;
          }
        } else if (isFixed && !shouldFix) {
          // 上にスクロール戻り → 即時解除（元位置にそのまま戻すのでアニメ不要）
          tabsEl.classList.remove('is-fixed');
          tabsEl.classList.remove('is-exiting');
          overlay.classList.remove('is-show');
          overlay.classList.remove('is-exiting');
          spacer.style.display = 'none';
          tabsEl.style.removeProperty('--pkmn-tab-sticky-top');
          isFixed = false;
        }
        isTicking = false;
      }

      window.addEventListener('scroll', function () {
        if (!isTicking) {
          requestAnimationFrame(update);
          isTicking = true;
        }
      }, { passive: true });
      // resize 時は state を強制リセットしてから再計算（リサイズ中の古い is-fixed/is-show が
      // 新しい viewport で間違った位置に残るのを防ぐ）
      window.addEventListener('resize', function () {
        if (isFixed) {
          tabsEl.classList.remove('is-fixed');
          tabsEl.classList.remove('is-exiting');
          overlay.classList.remove('is-show');
          overlay.classList.remove('is-exiting');
          spacer.style.display = 'none';
          tabsEl.style.removeProperty('--pkmn-tab-sticky-top');
          isFixed = false;
        }
        if (!isTicking) {
          requestAnimationFrame(update);
          isTicking = true;
        }
      }, { passive: true });
      update();
    }

    // ===========================================================
    // ループアニメーションを画面外で停止（CPU/GPU 消費抑制 / 2026-05-26 ユーザー指示）
    // - CSS の `animation-play-state: paused` をクラスで切り替える
    // - 対象: .Intro__snsBall (`pkmnSnsBallWobble` infinite)
    //   ※ Lifestyle Splide autoScroll と Detail サムネローテーションは別途実装済み
    // ===========================================================
    function initLoopAnimPauseOnOffscreen() {
      if (!('IntersectionObserver' in window)) return;
      var targets = document.querySelectorAll('.page-pokemon-v3 .Intro__snsBall');
      if (!targets.length) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('is-anim-paused', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      targets.forEach(function (el) { io.observe(el); });
    }

    // Detail 入場アニメ（初回画面到達時）。splide.on('active') の初回はスキップしているので、
    // ここの IO 経路だけが初回入場を担う。タブ切替の restartEntranceAnim 経路とは独立。
    // 初回 IO 経路では製品画像 (Detail__visualImg) は動かさず .Detail__character のみ発火する。
    function initDetailEntranceObserver() {
      var characters = document.querySelectorAll('.page-pokemon-v3 .Detail__character');
      if (!characters.length) return;

      function fireEntranceAnim(slideEl) {
        if (!slideEl || !slideEl.classList.contains('is-active')) return;
        var targets = Array.prototype.slice.call(slideEl.querySelectorAll('.Detail__character'));
        if (targets.length === 0) return;
        targets.forEach(function (el) { el.classList.remove('is-anim-in'); });
        // eslint-disable-next-line no-unused-expressions
        void slideEl.offsetWidth;
        targets.forEach(function (el) {
          // is-revealed は永続 — animation 完了後の表示維持に必要
          el.classList.add('is-revealed');
          el.classList.add('is-anim-in');
          var timer;
          var clear = function () {
            el.classList.remove('is-anim-in');
            el.removeEventListener('animationend', clear);
            if (timer) clearTimeout(timer);
          };
          el.addEventListener('animationend', clear);
          timer = setTimeout(clear, 1000);
        });
      }

      if (!('IntersectionObserver' in window)) {
        characters.forEach(function (c) {
          fireEntranceAnim(c.closest('.Detail__slide'));
        });
        return;
      }

      var firedSlides = new WeakSet();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var slideEl = entry.target.closest('.Detail__slide');
          if (slideEl) {
            if (slideEl.classList.contains('is-active')) {
              // active スライド：画面到達で入場アニメ（is-revealed + is-anim-in）。
              if (!firedSlides.has(slideEl)) {
                firedSlides.add(slideEl);
                fireEntranceAnim(slideEl);
              }
            } else {
              // 2026-06-02: type:'fade' は非 active スライドも active と同位置に重なり同時交差する。
              //   旧実装は is-active でない character を fireEntranceAnim でスキップしつつ即 unobserve し、
              //   初期 active が is-revealed を取り損ねて opacity:0 のまま固まる事故があった。
              //   非 active には is-revealed のみ付与して可視性を確保する（親 slide が opacity:0 制御なので
              //   見た目には出ない。タブ切替で表に出たら splide 側の restartEntranceAnim がアニメを担当）。
              entry.target.classList.add('is-revealed');
            }
          }
          io.unobserve(entry.target);
        });
      }, { threshold: 0.3 });

      characters.forEach(function (c) { io.observe(c); });
    }

    // ProductCard__thumb クリック → 対応する Detail タブを切替。
    // a[href="#detail-..."] のスムーススクロールは CSS scroll-behavior:smooth に任せ、
    // 同時に target Detail 内の Detail__tab[data-index="N"].click() を呼んで
    // splide / is-active / indicator を同期させる。
    function initIntroThumbTabLink() {
      var thumbs = document.querySelectorAll('.page-pokemon-v3 .Intro .ProductCard__thumb[data-tab-index]');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var href = thumb.getAttribute('href') || '';
          var index = thumb.getAttribute('data-tab-index');
          if (href.charAt(0) !== '#' || index === null) return;
          var section = document.querySelector(href);
          if (!section) return;
          var tab = section.querySelector('.Detail__tab[data-index="' + index + '"]');
          if (!tab) return;
          tab.click();
        });
      });
    }

    function init() {
      initKvAnimation();
      initTitleReveal('.page-pokemon-v3 .Intro__title, .page-pokemon-v3 .Detail__headingText');
      initIntroSplide();
      initLifestyleMarquee();
      initDetailSplide(
        '.js-splide-pokemon-v3-detail1',
        '.js-splide-pokemon-v3-detail1-tabs'
      );
      initDetailSplide(
        '.js-splide-pokemon-v3-detail2',
        '.js-splide-pokemon-v3-detail2-tabs'
      );
      initIntroThumbTabLink();
      initThumbRotationVisibility();
      initFaqTabs();
      initFaqAccordion();
      initVisibilityObserver();
      initDetailTabSticky('.Detail.-charger');
      initDetailTabSticky('.Detail.-audio');
      initLoopAnimPauseOnOffscreen();
      initDetailEntranceObserver();
    }

    if (document.readyState === 'complete') {
      init();
    } else {
      document.addEventListener('DOMContentLoaded', init);
    }
  })();
